import { render, staticRenderFns } from "./EspecieForm.vue?vue&type=template&id=c8a79022&scoped=true&lang=pug&"
import script from "./EspecieForm.vue?vue&type=script&lang=js&"
export * from "./EspecieForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a79022",
  null
  
)

export default component.exports